var map = {
	"./aed.svg": 40703,
	"./afn.svg": 37544,
	"./all.svg": 75692,
	"./amd.svg": 47687,
	"./ang.svg": 98185,
	"./aoa.svg": 11680,
	"./ars.svg": 56529,
	"./aud.svg": 69775,
	"./awg.svg": 60406,
	"./azn.svg": 65452,
	"./bam.svg": 64521,
	"./bbd.svg": 55129,
	"./bdt.svg": 82535,
	"./bgn.svg": 49552,
	"./bhd.svg": 37563,
	"./bif.svg": 80698,
	"./bmd.svg": 97996,
	"./bnd.svg": 13205,
	"./bob.svg": 26316,
	"./brl.svg": 47633,
	"./bsd.svg": 6678,
	"./btn.svg": 87293,
	"./bwp.svg": 19894,
	"./byn.svg": 69170,
	"./bzd.svg": 73761,
	"./cad.svg": 62925,
	"./cdf.svg": 93748,
	"./chf.svg": 73808,
	"./clf.svg": 2924,
	"./clp.svg": 57970,
	"./cnh.svg": 88988,
	"./cny.svg": 29549,
	"./cop.svg": 50599,
	"./crc.svg": 61275,
	"./cup.svg": 86597,
	"./cve.svg": 41777,
	"./czk.svg": 28683,
	"./djf.svg": 28013,
	"./dkk.svg": 13563,
	"./dop.svg": 44964,
	"./dzd.svg": 86863,
	"./egp.svg": 88357,
	"./ern.svg": 21440,
	"./etb.svg": 72382,
	"./eur.svg": 7293,
	"./fjd.svg": 82269,
	"./fkp.svg": 67142,
	"./gbp.svg": 2492,
	"./gel.svg": 88885,
	"./ggp.svg": 69435,
	"./ghs.svg": 84625,
	"./gip.svg": 11101,
	"./gmd.svg": 73173,
	"./gnf.svg": 79822,
	"./gtq.svg": 89223,
	"./gyd.svg": 35617,
	"./hkd.svg": 66616,
	"./hnl.svg": 54247,
	"./hrk.svg": 28740,
	"./htg.svg": 11022,
	"./huf.svg": 34712,
	"./idr.svg": 94250,
	"./ils.svg": 99667,
	"./imp.svg": 71299,
	"./inr.svg": 67468,
	"./iqd.svg": 52259,
	"./irr.svg": 87144,
	"./isk.svg": 30302,
	"./jep.svg": 18848,
	"./jmd.svg": 36068,
	"./jod.svg": 47514,
	"./jpy.svg": 65326,
	"./kes.svg": 24126,
	"./kgs.svg": 94564,
	"./khr.svg": 42788,
	"./kmf.svg": 47835,
	"./kpw.svg": 60657,
	"./krw.svg": 11743,
	"./kwd.svg": 95915,
	"./kyd.svg": 59149,
	"./kzt.svg": 28788,
	"./lak.svg": 6629,
	"./lbp.svg": 53395,
	"./lkr.svg": 48282,
	"./lrd.svg": 4319,
	"./lsl.svg": 48436,
	"./lyd.svg": 43386,
	"./mad.svg": 43711,
	"./mdl.svg": 25904,
	"./mga.svg": 8988,
	"./mkd.svg": 86701,
	"./mmk.svg": 46180,
	"./mnt.svg": 49350,
	"./mop.svg": 84661,
	"./mru.svg": 96259,
	"./mur.svg": 19365,
	"./mvr.svg": 86848,
	"./mwk.svg": 36230,
	"./mxn.svg": 99262,
	"./myr.svg": 6137,
	"./mzn.svg": 89040,
	"./nad.svg": 32916,
	"./ngn.svg": 57996,
	"./nio.svg": 91063,
	"./nok.svg": 15801,
	"./npr.svg": 43785,
	"./nzd.svg": 20229,
	"./omr.svg": 10531,
	"./pab.svg": 83552,
	"./pen.svg": 57640,
	"./pgk.svg": 49211,
	"./php.svg": 1749,
	"./pkr.svg": 30606,
	"./pln.svg": 54756,
	"./pyg.svg": 25733,
	"./qar.svg": 75237,
	"./ron.svg": 26984,
	"./rsd.svg": 5830,
	"./rub.svg": 73322,
	"./rwf.svg": 42120,
	"./sar.svg": 34067,
	"./sbd.svg": 41908,
	"./scr.svg": 10617,
	"./sdg.svg": 84978,
	"./sek.svg": 30494,
	"./sgd.svg": 69411,
	"./sll.svg": 7030,
	"./sos.svg": 52772,
	"./srd.svg": 28612,
	"./ssp.svg": 38347,
	"./std.svg": 97942,
	"./svc.svg": 7311,
	"./syp.svg": 96953,
	"./szl.svg": 68948,
	"./thb.svg": 98715,
	"./tjs.svg": 96608,
	"./tmt.svg": 86190,
	"./tnd.svg": 20091,
	"./top.svg": 94804,
	"./try.svg": 83330,
	"./ttd.svg": 85065,
	"./twd.svg": 29680,
	"./tzs.svg": 95536,
	"./uah.svg": 67587,
	"./ugx.svg": 6333,
	"./usd.svg": 82909,
	"./uyu.svg": 34286,
	"./uzs.svg": 73757,
	"./ves.svg": 73335,
	"./vnd.svg": 13897,
	"./vuv.svg": 80938,
	"./wst.svg": 25491,
	"./xof.svg": 44926,
	"./yer.svg": 5721,
	"./zar.svg": 75222,
	"./zmw.svg": 73687,
	"./zwl.svg": 86730
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 41723;